export default "<span class=\"mat-error\" [class.error--show]=\"isError\">{{control | validationError : name}}</span>"